<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">团队建设</span>
    </div>
    <div class="title-boxs">
      <!-- v-if="oldInfos?.id && !isEdit" -->
      <span class="btn-action-group">
        <a-button type="primary" @click="addGains" class="btn-action"
          >新增</a-button
        >
        <!-- <a-button @click="importsj()" class="btn-action">导入</a-button> -->
        <a-button class="btn-action" danger type="text" @click="batchDelete">
          批量移除</a-button
        >
      </span>
    </div>
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <!-- <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template> -->
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <!-- v-if="oldInfos?.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <!-- v-if="oldInfos?.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条团队建设的数据吗?</p>
    </a-modal>
    <!-- 添加团队建设 -->
    <AddTeamBuild ref="addGain" @addGain="addGaincz"></AddTeamBuild>
    <data-import ref="dataImport" @refreshData="addGain"></data-import>
  </div>
</template>
    
<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import AddTeamBuild from "./addTeamBuild.vue";

const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "名称",
    dataIndex: "buildName",
    id: "buildName",
    align: "center",
    width: 180,
  },
  {
    title: "年份",
    dataIndex: "acquireYear",
    id: "acquireYear",
    align: "center",
    width: 100,
  },
  {
    title: "数量",
    dataIndex: "amount",
    id: "amount",
    align: "center",
    width: 100,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 234,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
    };
  },
  watch: {
    "oldInfos.allteacherlist": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        console.log(newValue, "我是");
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  components: {
    AddTeamBuild,
    dataImport,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  mounted() {
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.getData();
  },
  methods: {
    importsj() {
      this.$refs.dataImport.init("team", this.oldInfos, "团队建设");
    },
    handleOk() {
      if (this.oldInfos?.id) {
        deleteAction("/lx/lxTeamBuilding/delete", {
          id: this.deteleId,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        console.log("3333");
        this.$message.success("移除成功");
        this.showDeleteModel = false;
        this.oldInfos.allteacherlist = this.oldInfos.allteacherlist.filter(
          (item) => item.id != this.deteleId
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    addGains() {
      this.$refs.addGain.init("add", this.oldInfos);
    },
    addGaincz(sj) {
      if (this.oldInfos?.id) {
        this.addGain();
      } else {
        if (sj.type == "add") {
          this.pagination.current = 1;
          this.oldInfos.allteacherlist.unshift({
            ...sj.record,
            id:
              sj.record.buildName +
              "团队建设" +
              this.oldInfos.allteacherlist.length,
          });
        } else {
          let index = this.oldInfos.allteacherlist.findIndex(
            (item) => item.id === sj.record.id
          );
          if (index !== -1) {
            // 如果找到相同的 id，替换该对象
            this.oldInfos.allteacherlist[index] = sj.record;
          }
        }
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    addGain() {
      //this.pagination.current = 1;
      this.getData();
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 1,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lx/lxTeamBuilding/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.allteacherlist &&
          this.oldInfos.allteacherlist.length > 0
        ) {
          this.pagination.total = this.oldInfos.allteacherlist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          let formatList = this.oldInfos.allteacherlist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.allteacherlist.slice(startIndex, endIndex);
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      // console.log("row", row);
      this.$refs.addGain.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      // let applyType = 1;
      // if (this.$route.name === "szStudio") {
      //   applyType = 1;
      // } else if (this.$route.name === "educationalBrand") {
      //   applyType = 2;
      // } else {
      //   applyType = 3;
      // }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的团队建设");
      } else {
        if (this.oldInfos?.id) {
          let params = {
            ids: this.selectedRowKeys.toString(),
          };
          deleteAction("/lx/lxTeamBuilding/deleteBatch", params).then((res) => {
            if (res.code == 200) {
              this.$message.success("批量移除成功");
              this.pagination.current = 1;
              this.getData();
              this.selectedRowKeys = [];
              this.$forceUpdate();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          //this.pagination.current = 1;
          this.oldInfos.allteacherlist = this.oldInfos.allteacherlist.filter(
            (item) => !this.selectedRowKeys.includes(item.id)
          );
          sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
          this.getData();
          this.selectedRowKeys = [];
        }
      }
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
    .title-boxs {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 20px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
</style>